import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseStatistic, Sport } from '@mtgame/core';
import { StatisticPlayerIdentity } from '../statistic-table/statistic-table.component';

@Component({
  selector: 'mtg-statistic-table-grouped',
  templateUrl: './statistic-table-grouped.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatisticTableGroupedComponent {
  @Input()
  sport: Sport;
  @Input()
  statistic: BaseStatistic[];
  @Input()
  pageSize = 1000;
  @Input()
  teamLogoVisible = true;
  @Input()
  identity: StatisticPlayerIdentity;
  @Input()
  sortByForward: string;
  @Input()
  sortByDefender: string;
  @Input()
  sortByGoalkeeper: string;
  @Input()
  checkNewbie = true;
}
